import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Order } from 'src/app/interfaces/orders';

@Injectable({
  providedIn: 'root'
})
export class SubscriberService {

  constructor(

  ) { }

  // App Configuration
  adminMode = new BehaviorSubject<boolean>(false);
  adminModeNext(newData: boolean) {
    this.adminMode.next(newData);
  }

  costDiscount = new BehaviorSubject<number>(0);
  costDiscountNext(newData: number) {
    this.costDiscount.next(newData);
  }



  productList = new BehaviorSubject<any[]>([]);
  productListNext(newData: any[]) {
    this.productList.next(newData);
  }

  googleContactList = new BehaviorSubject<any[]>([]);
  googleContactListNext(newData: any[]) {
    this.googleContactList.next(newData);
  }

  lexwareContactList = new BehaviorSubject<any[]>([]);
  lexwareContactListNext(newData: any[]) {
    this.lexwareContactList.next(newData);
  }

  orderList = new BehaviorSubject<Order[]>([]);
  orderListNext(newData: any[]) {
    this.orderList.next(newData);
  }

  offlineOrders = new BehaviorSubject<Order[]>([]);
  offlineOrdersNext(newData: any[]) {
    this.offlineOrders.next(newData);
  }

  // Aufträge, die nachweislich erfolgreich synchronisiert wurden — nur per Button löschbar, nie automatisch
  syncedOfflineOrders = new BehaviorSubject<Order[]>([]);
  syncedOfflineOrdersNext(newData: any[]) {
    this.syncedOfflineOrders.next(newData);
  }

  currentOrder = new BehaviorSubject<any>(null);
  currentOrdertNext(newData: any) {
    this.currentOrder.next(newData);
  }
  setCurrentOrder(newData: any) {
    this.currentOrder.next(newData);
  }

  // Wird gefeuert wenn nach einem 401 erfolgreich neu eingeloggt wurde
  syncRequested = new Subject<void>();
  requestSync() { this.syncRequested.next(); }

}
